// extracted by mini-css-extract-plugin
export default {"mainSpecs__skeleton":"mainSpecList_mainSpecs__skeleton__pJ5IA"};